import {WorkLocationType} from "@app/shared/enums/work-location-type.enum";

export class PayeeSettings {
  id: number;
  version: number;
  effectiveOn: Date;
  workLocationType: WorkLocationType;
  federalTaxExempt: boolean = false;
  socialSecurityExempt: boolean = false;
  stateTaxExempt: boolean = false;
  medicareExempt: boolean = false;
  allowOnlineAccess: boolean = false;
  nonresidentCertificateOnFile: boolean = false;
  disbursementType: string;
  payFrequency: string;
  statutoryEmployee: boolean = false;
  exemptFromWorkmenComp: boolean = false;
  workmenCompStateCode: string;
  payeeId: number;
  clientLocationId: number;
  standardHoursPerPeriod: number;
  eligibleJobTaxCredit: boolean = false;
  // SSCA related fields
  wageDeterminationId: number;
  wdContractId?: number;
  wdOccupationId: number;
  wdCountyCodeId: number;
  worksAlternateWorkWeek: boolean = false;
  // FIX ME: talk to Ron if we need to take this out of user obj
  companyPaidRetirement: boolean = false;
}



